import type { TFunction } from 'i18next';
import type { CreateInvoiceFormValues } from '../use-create-invoice';

export type InvoiceFormField = keyof CreateInvoiceFormValues;

export const validateInvoiceField = (
  field: InvoiceFormField,
  values: CreateInvoiceFormValues,
  t: TFunction
): string | undefined => {
  const required = t('payments.validation.required');

  switch (field) {
    case 'projectId':
      return values.projectId.trim() ? undefined : required;
    case 'amount':
      if (!values.amount.trim()) return required;
      if (Number.isNaN(Number(values.amount)) || Number(values.amount) <= 0) {
        return t('payments.validation.invalidAmount');
      }
      return undefined;
    case 'currencyCode':
      return values.currencyCode.trim() ? undefined : required;
    case 'expires':
      return values.expires ? undefined : required;
    default:
      return undefined;
  }
};

export const validateInvoiceForm = (
  values: CreateInvoiceFormValues,
  t: TFunction
): Record<string, string> => {
  const errors: Record<string, string> = {};
  const fields: InvoiceFormField[] = ['projectId', 'amount', 'currencyCode', 'expires'];

  for (const field of fields) {
    const error = validateInvoiceField(field, values, t);
    if (error) errors[field] = error;
  }

  return errors;
};
